<template>
  <div class="wrapper">
    <label
      class="switch"
      role="button"
      aria-labelledby="switch"
      tabindex="0"
      @click="updateValue"
      @keydown.enter="updateValue"
    >
      <span
        class="switch__slider"
        :class="output ? 'switch__slider--active' : ''"
      />
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      output: this.value
    }
  },
  methods: {
    updateValue () {
      this.output = !this.output
      this.$emit('input', this.output)
      this.$emit('change')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.wrapper {
  position: relative;

  .switch {
    position: relative;
    display: inline-block;
    width: 3rem;
    height: 1.625rem;

    &:hover {
      .switch__slider:not(.switch__slider--active) {
        background-color: $bg-1;

        &:before {
          background-color: $white;
        }
      }
    }

    &__slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: $bg-1;
      transition: background-color 0.2s ease;
      border-radius: 99rem;

      &:before {
        position: absolute;
        content: "";
        height: 1.25rem;
        width: 1.25rem;
        left: 0.1875rem;
        top: 0.1875rem;
        border-radius: 99rem;
        background-color: rgba($white, 0.5);
        transition: background-color 0.2s ease, transform 0.2s ease;
      }

      &--active {
        background-color: $blue;

        &:before {
          background-color: $white;
        }
      }

      &--active:before {
        transform: translateX(1.4375rem);
      }
    }

    &:focus {
      outline: none;
      border: none;

      .switch__slider {
        &:before {
          background-color: rgba($white, 1);
        }
      }
    }
  }
}
</style>
